import WeightCell from './component';
import { compose, mapProps } from 'recompose';
import { connect } from 'react-redux';

import numberWithCommas from 'utils/numberWithCommas';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';
import { IS_TENANT } from 'tenant/config';

const t = {
  kg: 'kg',
};

const fields = ['max_weight', 'total_weight', 'total_goods_weight'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      max_weight: maxWeight,
      total_weight: totalWeight,
      total_goods_weight: totalGoodsWeight,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);

    return {
      maxWeight,
      totalWeight: IS_TENANT ? totalGoodsWeight : totalWeight,
    };
  }),
  mapProps(({ maxWeight, totalWeight, showMax }) => ({
    weight: numberWithCommas(showMax && !IS_TENANT ? maxWeight : totalWeight),
    weightUnit: t.kg,
  }))
);

export default enhance(WeightCell);
